// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ls-0";
export var buttonContainer = "_ls-3";
export var cancelButton = "_ls-4";
export var headerSection = "_ls-6";
export var headerTitle = "_ls-9";
export var messageSideLeft = "_ls-1";
export var messageSideRight = "_ls-2";
export var orderNumberContainer = "_ls-7";
export var orderNumberLabel = "_ls-8";
export var submitButton = "_ls-5";